import axios from 'axios'
import React, { useContext, useEffect, useReducer } from 'react'
import reducer from '../reducers/products_reducer'
import { products_url as url } from '../utils/constants'
import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  GET_PRODUCTS_BEGIN,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_ERROR,
  GET_SINGLE_PRODUCT_BEGIN,
  GET_SINGLE_PRODUCT_SUCCESS,
  GET_SINGLE_PRODUCT_ERROR,
} from '../actions'

const initialState = {
isOpen:false,
products_loading:false,
products_error:false,
products:[],
featured_products:[],
single_product_loading:false,  
single_product_error:false,  
single_product:{},  
}

const ProductsContext = React.createContext()

export const ProductsProvider = ({ children }) => {

const [state,dispatch]=useReducer(reducer,initialState);

function openSideBar(){
  dispatch( { type : SIDEBAR_OPEN} );
}
function closeSideBar(){
  dispatch( { type : SIDEBAR_CLOSE} );
}

const fetchProduct=async function(){
dispatch({type:GET_PRODUCTS_BEGIN});
try{
const response=await axios.get(url);
const products=response.data; 
dispatch({type:GET_PRODUCTS_SUCCESS,payload:products});
}
catch(error){
dispatch({type:GET_PRODUCTS_ERROR});
}
}
const fetchSingleProduct=async function(url){
dispatch({type:GET_SINGLE_PRODUCT_BEGIN});
try{
const response=await axios.get(url);
const single_product=response.data;
dispatch({type:GET_SINGLE_PRODUCT_SUCCESS,payload:single_product}); 
}
catch(error){
dispatch({type:GET_SINGLE_PRODUCT_ERROR});
}
}

useEffect(()=>{
  fetchProduct(url);
},[]);

return (
    <ProductsContext.Provider value={{...state,openSideBar,closeSideBar,fetchSingleProduct}}>
      {children}
    </ProductsContext.Provider>
  )
}
// make sure use
export const useProductsContext = () => {
  return useContext(ProductsContext)
}
